/** Customer writing-style controls (compiled into a bounded style block for the reply writer). */
export const VOICE_TONES = ['friendly', 'neutral', 'professional'];
export const VOICE_LENGTHS = ['short', 'medium', 'long'];
export const VOICE_EMOJI = ['never', 'rare', 'ok'];
export const VOICE_STANCES = ['I', 'we'];
export const VOICE_LIMITS = { words: 20, wordChars: 40, examples: 3, exampleChars: 600, noteChars: 300 };
export const DEFAULT_VOICE = {
    tone: 'friendly',
    length: 'short',
    formality: 2,
    emoji: 'never',
    stance: 'I',
    avoid: [],
    prefer: [],
    examples: [],
    note: '',
};
export const DEFAULT_PROJECT_SETTINGS = {
    maxThreadAgeDays: 30,
    languages: ['en'],
    repliesEnabled: true,
    followupsEnabled: true,
    dmsEnabled: false,
    linksEnabled: true,
    minScore: 60,
    bannedPhrases: [],
    voiceNotes: '',
    voice: DEFAULT_VOICE,
};
export const DEFAULT_DAILY_CAPS = { comment: 4, followup: 6, dm: 3, warmup: 25, organic: 6 };
export const DEFAULT_WINDOWS = [1, 2, 3, 4, 5]
    .flatMap((day) => [
    { day, start: '08:30', end: '11:45' },
    { day, start: '13:15', end: '17:30' },
    { day, start: '20:00', end: '22:00' },
])
    .concat([0, 6].map((day) => ({ day, start: '10:00', end: '13:00' })));
//# sourceMappingURL=json.js.map